// extracted by mini-css-extract-plugin
export default {"tableStreamsHeader":"TableStreams_tableStreamsHeader__t0BzP"};